import {
    GAME_EVENT_STATUSES,
    MATCH_EVENT_STATUSES,
    TimelineData,
} from "../Timeline/Types";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export enum GAME_GENERAL_STATE {
    NOT_STARTED,
    MATCH_ABOUT_TO_START,
    IN_PROGRESS,
    HALFTIME,
    ENDED,
    CLOSED,
    CANCELLED,
    INTERRUPTED,
    INTERRUPTED_NO_UPDATES,
}

export function useGameGeneralState(timeline?: TimelineData) {
    const [gameState, setGameState] = useState(GAME_GENERAL_STATE.IN_PROGRESS);
    useEffect(() => {
        let currentState = GAME_GENERAL_STATE.IN_PROGRESS;

        switch (timeline?.sportEventStatus.matchStatus) {
            case MATCH_EVENT_STATUSES.HALFTIME:
                currentState = GAME_GENERAL_STATE.HALFTIME;
                break;
            case MATCH_EVENT_STATUSES.INTERRUPTED:
                currentState = GAME_GENERAL_STATE.INTERRUPTED;
                if (
                    timeline?.sportEventStatus.status ===
                    GAME_EVENT_STATUSES.INTERRUPTED
                ) {
                    currentState = GAME_GENERAL_STATE.INTERRUPTED_NO_UPDATES;
                }
                break;
            default:
                switch (timeline?.sportEventStatus.status) {
                    case GAME_EVENT_STATUSES.NOT_STARTED:
                    case GAME_EVENT_STATUSES.PENDING:
                        currentState = GAME_GENERAL_STATE.NOT_STARTED;
                        break;
                    case GAME_EVENT_STATUSES.MATCH_ABOUT_TO_START:
                        currentState = GAME_GENERAL_STATE.MATCH_ABOUT_TO_START;
                        break;
                    case GAME_EVENT_STATUSES.CLOSED:
                        currentState = GAME_GENERAL_STATE.CLOSED;
                        break;
                    case GAME_EVENT_STATUSES.ENDED:
                        currentState = GAME_GENERAL_STATE.ENDED;
                        break;
                    case GAME_EVENT_STATUSES.CANCELLED:
                        currentState = GAME_GENERAL_STATE.CANCELLED;
                        break;
                    case GAME_EVENT_STATUSES.INTERRUPTED:
                        currentState =
                            GAME_GENERAL_STATE.INTERRUPTED_NO_UPDATES;
                        break;
                }
        }
        setGameState(currentState);
    }, [timeline]);

    return gameState;
}

export function isMatchStartingToday(timeline: TimelineData) {
    return dayjs(timeline.sportEvent.startTime).diff(dayjs(), "h") < 24;
}

export function isMatchStartingSoon(timeline: TimelineData) {
    return dayjs(timeline.sportEvent.startTime).diff(dayjs(), "h") < 4;
}

export function isMatchNow(status: GAME_GENERAL_STATE) {
    return [
        GAME_GENERAL_STATE.IN_PROGRESS,
        GAME_GENERAL_STATE.HALFTIME,
    ].includes(status);
}

export function isMatchOngoingOrFinished(status: GAME_GENERAL_STATE) {
    return (
        isMatchNow(status) ||
        status === GAME_GENERAL_STATE.ENDED ||
        status === GAME_GENERAL_STATE.CLOSED
    );
}

export function isMatchClosedOrEndedOrCancelled(status: GAME_GENERAL_STATE) {
    return (
        [
            GAME_GENERAL_STATE.CLOSED,
            GAME_GENERAL_STATE.ENDED,
            GAME_GENERAL_STATE.CANCELLED,
        ].indexOf(status) !== -1
    );
}
